import { Component } from '@angular/core';

@Component({
  selector: 'waitingfrontend',
  templateUrl: './waitingfrontend.component.html',
  styleUrls: ['./waitingfrontend.component.less'],
})
export class WaitingFrontendComponent {}
